import { useLocation, useNavigate } from "react-router-dom";
import { TermsLookup } from "../../../models/Configuration"
import * as Yup from "yup";
import { apiStore } from "../../../api/ApiFactory";
import { Formik } from "formik";
import { MainCard } from "../../../components/surface/MainCard";
import { Grid, FormControlLabel, InputLabel, TextField, FormHelperText, Stack, Switch, Autocomplete, Checkbox } from "@mui/material";
import { Button } from "reactstrap";
import { SectionBox } from "../../../components/surface/SectionBox";
import SubmitButtonGroup from "../../../components/button/SubmitButtonGroup";
import { useEffect, useState } from "react";
import { LookupExtended } from "../../../models/Common";

const EditTermLookup = () => {

    const location = useLocation();
    const navigate = useNavigate();

    const state: any = location.state;
    const { option } = state;
    const data: TermsLookup = { ...option.data }
    const [seriesList, setSeriesList] = useState<LookupExtended[]>();

    useEffect(() => {
        let mounted = true;
        if (mounted) {

            apiStore.boatConfigApi.getSeriesList()
                .then((response) => {
                    const value: LookupExtended[] = response.data;
                    setSeriesList(value); 
                })
        }
        return () => {
          mounted = false
        }
      }, []);

    const validationSchema = Yup.object({
        name: Yup.string()
          .max(120, "Name is to long")
          .required("Name is required"),
        displayName: Yup.string()
          .max(120, "Name is to long"),
        description: Yup.string()
          .max(120, "Name is to long"),
        isActive: Yup.string()
          .max(120, "Name is to long")
          .required("Name is required"),
        order: Yup.number()
          .integer("Order must be an integer")
          .typeError("Order must be numeric"),
    });

    const initalValues: TermsLookup = {
        id: data?.id ? data.id : null,
        name: data?.name ? data.name : "",
        description: data.description ? data?.description : "",
        displayName: data?.displayName ? data?.displayName : "",
        isActive: data?.isActive ? data?.isActive : true,
        order: data?.order,
        seriesFinanceTerms: data?.seriesFinanceTerms ? data?.seriesFinanceTerms : []
    }

    const saveLookupOption = async (formData: TermsLookup) => {
        let response = await apiStore.lookupApi.saveFinanceTerm(formData);
        navigate(-1);
    }

    return (

        <Formik
            enableReinitialize
            initialValues={initalValues}
            validationSchema={validationSchema}
            onSubmit={((values: TermsLookup) => {saveLookupOption(values);
        })}
        >
        {
        ({  errors,
            handleChange,
            handleSubmit,
            getFieldProps,
            isSubmitting,
            setFieldValue,
            touched,
            values,
            status }) => 
            {
                return <form onSubmit={handleSubmit}>
                    <MainCard title={option.name} divider={true}>
                    <SectionBox>
                        <Grid container spacing={4} >
                            <Grid item xs={12}>
                                <FormControlLabel
                                control={
                                    <Switch
                                    id="isActive"
                                    name="isActive"
                                    checked={values.isActive}
                                    onChange={handleChange}
                                    />
                                }
                                label="Active"
                                />
                            </Grid>
                            <Grid item xs={12} md={6} xl={4}>
                                <InputLabel>Name *</InputLabel>
                                <TextField
                                id="name"
                                size="small"
                                placeholder="Name  *"
                                fullWidth
                                {...getFieldProps("name")}
                                error={Boolean(
                                    touched?.name && errors?.name
                                )}
                                />
                                {touched?.name && errors?.name && (
                                <FormHelperText error id="name-helper">
                                    {errors?.name}
                                </FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={6} xl={4}>
                                <InputLabel>Display Name *</InputLabel>
                                <TextField
                                id="displayName"
                                size="small"
                                placeholder="Display Name  *"
                                fullWidth
                                {...getFieldProps("displayName")}
                                error={Boolean(
                                    touched?.displayName && errors?.displayName
                                )}
                                />
                                {touched?.displayName && errors?.displayName && (
                                <FormHelperText error id="displayname-helper">
                                    {errors?.displayName}
                                </FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={6} xl={4}>
                                <InputLabel>Description *</InputLabel>
                                <TextField
                                id="description"
                                size="small"
                                placeholder="Description *"
                                fullWidth
                                {...getFieldProps("description")}
                                error={Boolean(
                                    touched?.description && errors?.description
                                )}
                                />
                                {touched?.description && errors?.description && (
                                <FormHelperText error id="description-helper">
                                    {errors?.description}
                                </FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={6} xl={4}>
                                <InputLabel>Order</InputLabel>
                                <TextField
                                id="order"
                                size="small"
                                placeholder="Display Order"
                                fullWidth
                                {...getFieldProps("order")}
                                error={Boolean(
                                    touched?.order && errors?.order
                                )}
                                />
                                {touched?.order && errors?.order && (
                                <FormHelperText error id="order-helper">
                                    {errors?.order}
                                </FormHelperText>
                                )}
                            </Grid>

                            {seriesList !== undefined && (
                            <Grid item xs={12} md={6} xl={4}>
                                <InputLabel>Series *</InputLabel>
                                <Autocomplete
                                    multiple
                                    defaultValue={data?.seriesFinanceTerms}
                                    disablePortal
                                    size="small"
                                    fullWidth
                                    id="seriesFinanceTerms"
                                    disableCloseOnSelect
                                    isOptionEqualToValue={(option, value) => {return option.id === value.id;}}
                                    options={ seriesList! }
                                    getOptionLabel={(option: LookupExtended) => { return option.name  }
                                    }
                                    renderInput={(params) => (
                                        <TextField {...params} name="seriesFinanceTerms"></TextField>
                                    )}
                                    onChange={(event: any, newValue) => {
                                        setFieldValue("seriesFinanceTerms", newValue);
                                    }}   
                                    renderOption={(props, option: any, { selected }) => (
                                        <li {...props}>
                                            <Checkbox style={{ marginRight: 8 }} checked={selected}/>
                                            {option.name}
                                        </li>
                                    )}
                                />
                            </Grid>
                            )}
                            
                            <Grid item xs={12}>
                                <SubmitButtonGroup disabled={isSubmitting} />
                            </Grid>
                        </Grid>
                    </SectionBox>
                </MainCard>
            </form>
            }
      }
    </Formik>
    )


}

export default EditTermLookup;